import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";
import Home from "../views/home/Home";
import Login from "../views/login/Login";
import Raffles from '../views/Raffles/Raffles';
import Tickets from '../views/tickets/tickets';
import Questions from '../views/questions/Questions';
import Layout from "../components/Layout";
import NotFound from "../views/notFound";
import VerifyTickets from "../views/verifyTickets";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/rifas" element={<Raffles />} />
      <Route path="/boletos/:raffleId" element={<Tickets />} />
      <Route path="/preguntas" element={<Questions />} />
      <Route path="/verificar-boletos" element={<VerifyTickets />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

const MyRoutes = () => {
  return (
    <RouterProvider router={router} />
  );
};

export default MyRoutes;